<template>
  <q-dialog
    ref="dialogRef"
    :model-value="true"
    class="delete-project-dialog"
    @hide="onDialogHide"
  >
    <q-card style="max-width: 80vw">
      <q-card-section>
        <div class="text-h2 q-px-md">
          {{
            $t("project-deletion-dialog.title", {
              project: props.projectName,
            })
          }}
        </div>

        <ul>
          <li
            v-for="(message, ndx) in $tm('project-deletion-dialog.messages')"
            :key="ndx"
          >
            {{ message }}
          </li>
        </ul>
        <div class="q-px-md">
          {{ $t("project-deletion-dialog.hint") }}
        </div>
        <div class="q-pa-md">
          {{ $t("project-deletion-dialog.confirmation-message") }}
        </div>
        <div class="q-px-md" style="display: flex; flex-direction: row">
          <q-input
            ref="inputRef"
            v-model="enteredProjectName"
            dense
            outlined
            autofocus
            :placeholder="props.projectName"
            class="project-name-confirmation"
            style="flex-grow: 1"
            :rules="[
              (val) => (val && val.length > 0) || $t('input.required'),
              (val) =>
                val == props.projectName ||
                $t('project-deletion-dialog.error.incorrect-project-name'),
            ]"
            lazy-rules
          />
        </div>
      </q-card-section>
      <q-card-actions align="right" class="q-px-lg">
        <q-btn
          :label="$t('project-deletion-dialog.cancel-button')"
          color="primary"
          flat
          class="cancel-button"
          @click="onDialogCancel()"
        />
        <q-btn
          :label="$t('project-deletion-dialog.ok-button')"
          color="negative"
          class="ok-button"
          @click="inputRef?.validate() ? onDialogOK() : undefined"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { QInput, useDialogPluginComponent } from "quasar";

defineEmits({ ...useDialogPluginComponent.emitsObject });
const props = defineProps<{
  projectName: string;
}>();

const enteredProjectName = ref();
const inputRef = ref();

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } =
  useDialogPluginComponent();
</script>
